import { useLinks } from 'components/Header/hooks/useLinks';

import style from '../Header.module.css';

const Links = () => {
  const links = useLinks();

  return links.map(route => (
    <a href={route.to} className={style.navItem} key={route.to}>
      <route.Icon />
      {route.label}
    </a>
  ))
};

export default Links;